import Rec from '../data/eventpics/recruitment.png';
import { Card } from 'react-bootstrap';

function Recruitment() {
    const aboutBackGround = {
        background: "linear-gradient(to bottom, white 30%, rgb(153, 204, 255) 70%)",
        backgroundSize: "cover",
        boxSizing: "content-box",
        padding: "3%",
        paddingLeft: "20%"
    };

    const intro = "MTSA recruitment is back! Interested in all things Taiwan? Looking to join an active, fun, and vibrant community? Want to get involved in planning exciting social events and create wonderful memories? Look no further, for the MTSA fam is looking for someone like you!";

    return <div id="rec" style={aboutBackGround}>
        <h1 style={{fontSize: "calc(20px + 3vw)", paddingBottom: "2%", fontFamily: "Inter, sans-serif"}}>RECRUITMENT</h1>
        <Card style={{width: "60vw", border: "none"}}>
            <Card.Img variant="top" src={Rec} />
            <Card.Body style={{backgroundColor: "white"}}>
                <Card.Text style={{fontSize: "1.5vw", fontFamily: "Inter, sans-serif", textAlign: "center"}}>{intro}</Card.Text>
            </Card.Body>
        </Card>
    </div>;
}

export default Recruitment;